import { XCircleIcon, ArrowRightOnRectangleIcon, AtSymbolIcon, ExclamationTriangleIcon, KeyIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "app/hooks";
import jwtDecode from "jwt-decode";
import jwtEncode from 'jwt-encode';
import { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  ButtonSecondary,
  FloatInput
} from "../../../components";
import { signIn, signOut } from "../services/AuthSlice";
import { GET_AUTHSYSTEM } from "../services/AuthSystemSlice";

import { getData, storeData } from "utils/storage";

export interface PageLoginProps {
  className?: string;
}

type LoginForm = {
  username: string;
  password: string;
};

const Login: FC<PageLoginProps> = ({ className = "" }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isSignInSuccess, isError, isFetching, errorMessage, isAuth, data } =
    useAppSelector((state) => state.auth);

  const {
    isSuccess: isSuccessAuthSystem,
    isError: isErrorAuthSystem,
    isFetching: isFetchingAuthSystem,
    errorMessage: errorMessageAuthSystem } =
    useAppSelector((state) => state.authsystem);

  const [client, setClientId] = useState<boolean | null>(false)
  const [profile, setProfile] = useState<any | null>(false)
  const [credential, setCredential] = useState<any | null>(false)

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(40, "Password must not exceed 40 characters"),
  });

  const {
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<LoginForm>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    const _callback = searchParams.get("callback")
    const _data = getData("token")
    const _credential = getData("credential")

    if (_data) {
      const _profile = jwtDecode(_data)
      setProfile(_profile)
    }

    if (_credential) {
      setCredential(_credential)
    }

    async function checkClientID() {
      const client_id = searchParams.get("client-id")

      dispatch(GET_AUTHSYSTEM({
        "X-System-Auth": client_id
      }))
    }

    checkClientID()

    if (isSuccessAuthSystem && _callback) {
      setClientId(true)
    }

    if (isSignInSuccess) {
      storeData("credential", jwtEncode(data, 'BPJPH-GREATEDU-AUTH'))
      setCredential(jwtEncode(data, 'BPJPH-GREATEDU-AUTH'))
    }

  }, [dispatch, isSignInSuccess, searchParams, isSuccessAuthSystem, data]);

  const doLogin = (data: LoginForm) => {
    const client_id = searchParams.get("client-id")

    dispatch(
      signIn({
        data: {
          LOGIN: {
            emailAddr: data.username,
            password: data.password,
          },
        },
        header: {
          "X-System-Auth": client_id
        }
      })
    );
  };

  const doSelanjutnnyya = () => {
    const callback = searchParams.get("callback")

    // console.log(getData("token"))
    if (callback && getData("token")) {
      // console.log(callback + "?credential=" + credential)
      window.location.replace(callback + "?credential=" + getData("token"));
    }

    // console.log(callback)
  }

  const doLogout = () => {
    dispatch(signOut({}));
  }

  const clientAccess = () => {
    return (
      <>
        <div className="my-5"></div>
        <div
          className="p-1 px-2 text-xs rounded-full bg-green-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert">
          <span className="flex mr-3">
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="3"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </span>
          <span className="font-semibold mr-2 text-left flex-auto">
            Check client access
          </span>
          <ExclamationTriangleIcon className="w-5 text-green-500" />
        </div></>
    )
  }


  const clientReject = () => {
    return (
      <>
        <div className="my-5"></div>
        <div
          className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
          role="alert">
          <span className="flex mr-3">
            <XCircleIcon className="w-5 text-red-500" />
          </span>
          <span className="font-semibold mr-2 text-left flex-auto">
            Akses ditolak
          </span>
          <svg
            className="fill-current opacity-75 h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
            <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
          </svg>
        </div>
      </>
    )
  }

  const renderForm = () => {
    return (
      <>
        <p className="text-sm font-normal text-gray-500 my-8">
          Sistem OAuth sihalal, gunakan email dan kata sandi sihalal untuk mendapatkan akses
        </p>

        <div className="mb-2"></div>
        <FloatInput
          Icon={UserCircleIcon}
          disabled={!client}
          type="text"
          label="Email / Username"
          id="email"
          {...register("username")}
          isError={errors.username}
          errorMessage={errors.username?.message}
        />
        <div className="mb-2"></div>
        <FloatInput
          Icon={KeyIcon}
          disabled={!client}
          type="password"
          id="password"
          label="Kata Sandi"
          {...register("password")}
          isError={errors.password}
          errorMessage={errors.password?.message}
        />
        {isError && (
          <>
            <div className="mb-2"></div>
            <div
              className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
              role="alert">
              <span className="flex mr-3">
                <XCircleIcon className="w-5 text-red-500" />
              </span>
              <span className="font-semibold mr-2 text-left flex-auto">
                {errorMessage}
              </span>
              <svg
                className="fill-current opacity-75 h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
              </svg>
            </div>
          </>
        )}
        <div className="mb-6"></div>
        <ButtonPrimary
          disabled={!client}
          loading={isFetching}
          className="w-full"
          type="submit">
          Masuk
        </ButtonPrimary>
      </>
    )
  }

  return (
    <div className={`nc-PageLogin bg-gray-100 ${className}`} data-nc-id="PageLogin">
      <div className="container h-screen flex w-full justify-center">
        <div className="flex w-full lg:w-1/2 justify-center items-center ">
          <div className="w-full md:px-32 lg:px-24">

            <form
              onSubmit={handleSubmit(doLogin)}
              className="bg-white rounded-md shadow-2xl p-3 md:p-5 -mt-40">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
              </div>
              {/* <h1 className="text-gray-600 font-bold text-2xl">
                Selamat Datang
              </h1>*/}


              {
                isFetchingAuthSystem ? <>
                  {clientAccess()}
                </> : <>
                  {
                    client ? <> {
                      isAuth ? <>
                        <h1 className="mt-10 text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                          <span>
                            Hi, <span className="font-semibold">{profile?.email_addr}</span>
                          </span>
                          <div className="my-4"></div>
                          <div className="flex flex-row space-x-3 w-full">
                            <ButtonSecondary
                              disabled={!client}
                              loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doLogout()}
                            >
                              Keluar <XCircleIcon className="font-bold ml-5 w-6" />
                            </ButtonSecondary>
                            <ButtonPrimary
                              disabled={!client}
                              loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doSelanjutnnyya()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" />
                            </ButtonPrimary>
                          </div>
                        </h1>
                      </> : <>
                        {renderForm()}</>
                    }
                    </> : <>
                      {clientReject()}
                    </>
                  }
                </>
              }

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
